import { Container } from "react-bootstrap";
import Navigation from "../../../Components/Navbar";
import Servicos from './servicos';
const Oficina = () => {

    return (
        <>
        <Navigation />
        <div className="container-lg">
            <Servicos />
        </div>
        </>
    )
}

export default Oficina;